import React from 'react';

class LoadableIntlTelInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IntlTelInput: null,
    };
  }

  componentWillMount() {
    import(
      /* webpackChunkName: "intltelinput" */
      // eslint-disable-next-line
      'react-intl-tel-input'
    ).then((IntlTelInput) => {
      this.setState({ IntlTelInput: IntlTelInput.default });
    });
  }

  render() {
    const {
      IntlTelInput,
    } = this.state;
    if (IntlTelInput) {
      const {
        setPhoneInputRef,
        ...props
      } = this.props;
      return (
        <IntlTelInput
          {...(setPhoneInputRef ? {
            ref: setPhoneInputRef,
          } : {})}
          {...props}
        />
      );
    }
    return null;
  }
}

export default LoadableIntlTelInput;
